import { ReactNode } from 'react';
import * as Styled from './BasicHeader.styled';

import type { BasicHeaderProps } from './BasicHeader.typed';

function BasicHeader(props: BasicHeaderProps) {
  const {
    title,
    metaData,
    titleSmallFontSize = 'L18',
    titleMediumFontSize = 'L18',
    keyInfoItemSmallFontSize = 'M14',
    titleLineClamp = 2,
  } = props;

  return (
    <div>
      <Styled.Title
        titleSmallFontSize={titleSmallFontSize}
        titleMediumFontSize={titleMediumFontSize}
        titleLineClamp={titleLineClamp}
      >
        {title}
      </Styled.Title>
      {metaData && (
        <Styled.KeyInfoList>
          {metaData.map(
            (item: ReactNode, index: number) =>
              item && (
                <Styled.KeyInfoItem
                  key={`card-key-info-item-${index}`}
                  keyInfoItemSmallFontSize={keyInfoItemSmallFontSize}
                >
                  {item}
                </Styled.KeyInfoItem>
              ),
          )}
        </Styled.KeyInfoList>
      )}
    </div>
  );
}

export { BasicHeader };
